const FORUM_INVITE_RETURN_STORAGE_KEY = "fintheon:forum-invite-return-url";
const AUTH_QUERY_PARAMS = [
  "access_token",
  "code",
  "error",
  "error_code",
  "error_description",
  "expires_in",
  "provider_token",
  "refresh_token",
  "state",
  "token_type",
  "type",
];

export function buildForumInviteUrl(rawHref: string): string {
  const url = new URL(stripAuthParamsFromUrl(rawHref));
  url.searchParams.set("tab", "analysis");
  url.searchParams.set("view", "forum");
  url.searchParams.set("forumInvite", "1");
  return url.toString();
}

export function isForumInviteUrl(rawHref: string): boolean {
  try {
    const url = new URL(rawHref);
    return url.searchParams.get("forumInvite") === "1";
  } catch {
    return false;
  }
}

export function stripAuthParamsFromUrl(rawHref: string): string {
  const url = new URL(rawHref);
  for (const param of AUTH_QUERY_PARAMS) url.searchParams.delete(param);

  const hash = url.hash.startsWith("#") ? url.hash.slice(1) : url.hash;
  if (hash) {
    const hashParams = new URLSearchParams(hash);
    let changed = false;
    for (const param of AUTH_QUERY_PARAMS) {
      if (hashParams.has(param)) changed = true;
      hashParams.delete(param);
    }
    url.hash = changed && hashParams.toString() ? `#${hashParams}` : "";
  }

  return url.toString();
}

export function buildHistoryPathWithoutAuthParams(rawHref: string): string {
  const url = new URL(stripAuthParamsFromUrl(rawHref));
  return `${url.pathname}${url.search}${url.hash}`;
}

export function rememberCurrentForumInviteReturnUrl(): string | null {
  if (typeof window === "undefined") return null;
  if (!isForumInviteUrl(window.location.href)) return null;
  const returnUrl = buildForumInviteUrl(window.location.href);
  try {
    window.sessionStorage.setItem(FORUM_INVITE_RETURN_STORAGE_KEY, returnUrl);
  } catch {
    /* session storage can be blocked */
  }
  return returnUrl;
}

export function consumeForumInviteReturnUrl(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(FORUM_INVITE_RETURN_STORAGE_KEY);
    window.sessionStorage.removeItem(FORUM_INVITE_RETURN_STORAGE_KEY);
    if (!raw) return null;
    const url = new URL(raw);
    if (url.origin !== window.location.origin) return null;
    return buildForumInviteUrl(url.toString());
  } catch {
    return null;
  }
}
